import { GadgetSystemDominionId } from "../../database/DominionLiterals";
import { FieldType } from "../../type-system/FieldType";
import { ShopifyApiVersion } from "./ShopifyApiVersion";
import { ShopifyDominion } from "./ShopifyDominion";
import { ConnectionModelSpecVersion, buildConnectionSpec } from "./ShopifyMetadata";
import {
  ShopifyFileKey,
  ShopifyProductVariantKey,
  ShopifyProductVariantMediaIdKey,
  ShopifyProductVariantMediaKey,
  ShopifyProductVariantMediaToFileKey,
  ShopifyProductVariantMediaToProductVariantKey,
  ShopifyProductVariantMediaToShopKey,
  ShopifyShopKey,
} from "./keys";

const specs: ConnectionModelSpecVersion = {
  key: ShopifyProductVariantMediaKey,
  "2024-07": {
    name: "Shopify Product Variant Media",
    fields: [
      {
        name: "ID",
        key: ShopifyProductVariantMediaIdKey,
        fieldType: FieldType.ID,
        dominionID: GadgetSystemDominionId,
      },
      {
        name: "Product Variant",
        fieldType: FieldType.BelongsTo,
        key: ShopifyProductVariantMediaToProductVariantKey,
        configuration: {
          relatedModelKey: ShopifyProductVariantKey,
        },
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "product_variant_id",
            graphQLFieldKey: "productVariantId",
            skipGraphQLSelection: true,
          },
        },
      },
      {
        name: "File",
        fieldType: FieldType.BelongsTo,
        key: ShopifyProductVariantMediaToFileKey,
        configuration: {
          relatedModelKey: ShopifyFileKey,
        },
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "file_id",
            graphQLFieldKey: "fileId",
            inheritSelectionFrom: ShopifyFileKey,
            skipGraphQLFragments: ["GenericFile"],
          },
        },
      },
      {
        name: "Shop",
        fieldType: FieldType.BelongsTo,
        key: ShopifyProductVariantMediaToShopKey,
        configuration: {
          relatedModelKey: ShopifyShopKey,
        },
      },
    ],
    syncConfig: { type: "graphql_sublist", parent: "product.variants", resource: "productVariant.media" },
  },
};

export const ShopifyProductVariantMedia = ({
  apiVersion,
  frameworkVersionConstraint,
  webhookTopicsForModel,
}: {
  apiVersion: ShopifyApiVersion;
  frameworkVersionConstraint?: string;
  webhookTopicsForModel?: string[];
}) => buildConnectionSpec(specs, apiVersion, frameworkVersionConstraint, webhookTopicsForModel);
